import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Avatar } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import { IVanHost } from 'src/store/reducers/host/types';
import './styles.scss';

interface IProps {
  host: IVanHost;
  location: string;
}

const HostCard: FC<IProps> = ({ host, location }) => {
  return (
    <div className='host-card'>
      <div className='client__order__main__header'>
        <h4>Hosted by</h4>
      </div>
      <div className='host-card__container'>
        <Avatar
          alt='user photo'
          src={host.photo ?? '/broken-image.jpg'}
          sx={{ width: '80px', height: '80px' }}
        />
        <div className='host-card__main-info'>
          <div className='host-card__main-info__name'>{host.first_name}</div>
          <div className='host-card__main-info__location'>{location}</div>
          <div className='host-card__main-info__wrapper'>
            <span className='host-card__main-info__rating'>4.9</span>
            <StarIcon />
            <Link
              to={`/host/reviews/${host.host_tag[0]}`}
              target='_blank'
              className='host-card__main-info__reviews'
            >
              Lots of reviews
            </Link>
          </div>
        </div>
      </div>
      <div className='host-card__bottom'>
        <div className='host-card__bottom__verified'>
          <img src='../images/shield-tick.png' alt='verified' />
          <span>Identity verified</span>
        </div>
        <p className='host-card__bottom__joined'>Joined Feb 2020</p>
      </div>
      <h5>
        <b>TEXT/CALL: </b>
        {host.phone}
      </h5>
    </div>
  );
};

export default HostCard;
